import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "validate-address-dialog py-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h4", { class: "mb-0 h4 px-3" }, "Address Validation"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("div", { class: "me-2 ai-essential-address-btn" }),
  /*#__PURE__*/_createElementVNode("hr")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "px-3 py-2" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" The patient's primary address will be used for documentation, claims and verifying location on a mobile device. Suggested changes are marked in "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "red"),
  /*#__PURE__*/_createTextVNode(". ")
], -1 /* HOISTED */)
const _hoisted_6 = { class: "row g-0" }
const _hoisted_7 = { class: "col-12 col-sm-6 pe-sm-2 d-flex border-bottom" }
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Primary Address", -1 /* HOISTED */)
const _hoisted_10 = { class: "card-text" }
const _hoisted_11 = {
  key: 0,
  class: "m-0"
}
const _hoisted_12 = { class: "m-0" }
const _hoisted_13 = { class: "m-0" }
const _hoisted_14 = { class: "m-0" }
const _hoisted_15 = { class: "m-0" }
const _hoisted_16 = { class: "col-12 col-sm-6 d-flex border-bottom" }
const _hoisted_17 = { class: "card-body axxess-intelligence-border" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Validated Primary Address", -1 /* HOISTED */)
const _hoisted_19 = { class: "card-text" }
const _hoisted_20 = { class: "`m-0 {originalAddressCountry && updatedAddressCountry && originalAddressCountry === updatedAddressCountry ? '' : 'text-danger'}`" }
const _hoisted_21 = { class: "form-check pt-4 mt-4 ps-4 ms-4" }
const _hoisted_22 = { class: "form-check-label" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" Update Primary ")
const _hoisted_24 = {
  key: 0,
  class: "col-12 d-flex"
}
const _hoisted_25 = { class: "col-12 col-sm-6 pe-sm-2 ps-0 d-flex border-bottom" }
const _hoisted_26 = { class: "card-body" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Visiting Address", -1 /* HOISTED */)
const _hoisted_28 = { class: "card-text" }
const _hoisted_29 = {
  key: 0,
  class: "m-0"
}
const _hoisted_30 = { class: "m-0" }
const _hoisted_31 = { class: "m-0" }
const _hoisted_32 = { class: "m-0" }
const _hoisted_33 = { class: "m-0" }
const _hoisted_34 = { class: "col-12 col-sm-6 px-0 d-flex border-bottom" }
const _hoisted_35 = { class: "card-body me-1" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Validated Visiting Address", -1 /* HOISTED */)
const _hoisted_37 = { class: "card-text" }
const _hoisted_38 = { class: "form-check pt-4 mt-4 ps-4 ms-4" }
const _hoisted_39 = { class: "form-check-label" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode(" Update Visit ")
const _hoisted_41 = { class: "col-12 col-sm-6 pe-sm-2 d-flex border-bottom" }
const _hoisted_42 = { class: "card-body" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Mailing Address", -1 /* HOISTED */)
const _hoisted_44 = { class: "card-text" }
const _hoisted_45 = {
  key: 0,
  class: "m-0"
}
const _hoisted_46 = { class: "m-0" }
const _hoisted_47 = { class: "m-0" }
const _hoisted_48 = { class: "m-0" }
const _hoisted_49 = { class: "m-0" }
const _hoisted_50 = { class: "col-12 col-sm-6 d-flex border-bottom" }
const _hoisted_51 = { class: "card-body" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("h5", { class: "card-title" }, "Validated Mailing Address", -1 /* HOISTED */)
const _hoisted_53 = { class: "card-text" }
const _hoisted_54 = {
  class: /*#__PURE__*/_normalizeClass(`m-0 {originalAddressCountry && updatedAddressCountry && originalAddressCountry === updatedAddressCountry ? '' : 'text-danger'}`)
}
const _hoisted_55 = { class: "form-check pt-4 mt-4 ps-4 ms-4" }
const _hoisted_56 = { class: "form-check-label" }
const _hoisted_57 = /*#__PURE__*/_createTextVNode(" Update Mailing ")
const _hoisted_58 = { key: 1 }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("p", null, "Please enter Address to Validate.", -1 /* HOISTED */)
const _hoisted_60 = [
  _hoisted_59
]
const _hoisted_61 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_62 = { class: "d-flex justify-content-end px-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_ctx.validAddress)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("address", null, [
                        _createTextVNode(_toDisplayString(_ctx.options.originalAddress.addressLine1) + " ", 1 /* TEXT */),
                        (_ctx.options.originalAddress.addressLine2?.length > 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(_ctx.options.originalAddress.addressLine2), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.options.originalAddress.city), 1 /* TEXT */),
                        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.options.originalAddress.state) + " " + _toDisplayString(_ctx.options.originalAddress.zipCode
                                            ? "," : "") + " " + _toDisplayString(_ctx.formatZipCode(_ctx.options.originalAddress.zipCode)), 1 /* TEXT */),
                        _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.options.originalAddress.county), 1 /* TEXT */),
                        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.originalAddressCountry), 1 /* TEXT */)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("address", null, [
                        _createElementVNode("p", {
                          class: _normalizeClass(`m-0 ${_ctx.checkEqualAddress(_ctx.options.originalAddress.addressLine1, _ctx.options.updatedAddress.addressLine1)}`)
                        }, _toDisplayString(_ctx.options.updatedAddress.addressLine1), 3 /* TEXT, CLASS */),
                        _createElementVNode("p", {
                          class: _normalizeClass(`m-0 ${_ctx.checkEqualAddress(_ctx.options.originalAddress.addressLine2, _ctx.options.updatedAddress.addressLine2)}`)
                        }, _toDisplayString(_ctx.options.updatedAddress.addressLine2), 3 /* TEXT, CLASS */),
                        _createElementVNode("p", {
                          class: _normalizeClass(`m-0 ${_ctx.checkEqualAddress(_ctx.options.originalAddress.city, _ctx.options.updatedAddress.city)}`)
                        }, _toDisplayString(_ctx.options.updatedAddress.city), 3 /* TEXT, CLASS */),
                        _createElementVNode("p", {
                          class: _normalizeClass(`m-0 ${_ctx.checkEqualAddress(_ctx.options.originalAddress.state, _ctx.options.updatedAddress.state)} 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               ${_ctx.checkEqualAddress(_ctx.options.originalAddress.zipCode, _ctx.options.updatedAddress.zipCode)}`)
                        }, _toDisplayString(_ctx.options.updatedAddress.state) + " " + _toDisplayString(_ctx.options.updatedAddress.zipCode ? "," : "") + " " + _toDisplayString(_ctx.formatZipCode(_ctx.options.updatedAddress.zipCode)), 3 /* TEXT, CLASS */),
                        _createElementVNode("p", {
                          class: _normalizeClass(`m-0 ${_ctx.checkEqualAddress(_ctx.options.originalAddress.county, _ctx.options.updatedAddress.county)}`)
                        }, _toDisplayString(_ctx.options.updatedAddress.county), 3 /* TEXT, CLASS */),
                        _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.updatedAddressCountry), 1 /* TEXT */)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("label", _hoisted_22, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input au-target",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.options.updatedAddress.primaryUpdate) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelCheckbox, _ctx.options.updatedAddress.primaryUpdate]
                    ]),
                    _hoisted_23
                  ])
                ])
              ]),
              (_ctx.validVisitAddress === true)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_26, [
                          _hoisted_27,
                          _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("address", null, [
                              _createTextVNode(_toDisplayString(_ctx.options.originalAddress.visitAddressLine1) + " ", 1 /* TEXT */),
                              (_ctx.options.originalAddress.visitAddressLine2?.length > 0)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_29, _toDisplayString(_ctx.options.originalAddress.visitAddressLine2), 1 /* TEXT */))
                                : _createCommentVNode("v-if", true),
                              _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.options.originalAddress.visitCity), 1 /* TEXT */),
                              _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.options.originalAddress.visitState) + " " + _toDisplayString(_ctx.options.originalAddress.visitZipCode ? "," : "") + " " + _toDisplayString(_ctx.formatZipCode(_ctx.options.originalAddress.visitZipCode)), 1 /* TEXT */),
                              _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.options.originalAddress.visitCounty), 1 /* TEXT */),
                              _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.originalAddressCountry), 1 /* TEXT */)
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_35, [
                          _hoisted_36,
                          _createElementVNode("div", _hoisted_37, [
                            _createElementVNode("address", null, [
                              _createElementVNode("p", {
                                class: _normalizeClass(`m-0 ${_ctx.checkEqualAddress(_ctx.options.originalAddress.visitAddressLine1, _ctx.options.updatedAddress.visitAddressLine1)}`)
                              }, _toDisplayString(_ctx.options.updatedAddress.visitAddressLine1), 3 /* TEXT, CLASS */),
                              (_ctx.options.updatedAddress.visitAddressLine2?.length > 0)
                                ? (_openBlock(), _createElementBlock("p", {
                                    key: 0,
                                    class: _normalizeClass(`m-0 ${_ctx.checkEqualAddress(_ctx.options.originalAddress.visitAddressLine2, _ctx.options.updatedAddress.visitAddressLine2)}`)
                                  }, _toDisplayString(_ctx.options.updatedAddress.visitAddressLine2), 3 /* TEXT, CLASS */))
                                : _createCommentVNode("v-if", true),
                              _createElementVNode("p", {
                                class: _normalizeClass(`m-0 ${_ctx.checkEqualAddress(_ctx.options.originalAddress.visitCity, _ctx.options.updatedAddress.visitCity)}`)
                              }, _toDisplayString(_ctx.options.updatedAddress.visitCity), 3 /* TEXT, CLASS */),
                              _createElementVNode("p", {
                                class: _normalizeClass(`m-0 ${_ctx.checkEqualAddress(_ctx.options.originalAddress.visitState, _ctx.options.updatedAddress.visitState)}
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                ${_ctx.checkEqualAddress(_ctx.options.originalAddress.visitZipCode, _ctx.options.updatedAddress.visitZipCode)}`)
                              }, _toDisplayString(_ctx.options.updatedAddress.visitState) + " " + _toDisplayString(_ctx.options.updatedAddress.visitZipCode
                                                    ? "," : "") + " " + _toDisplayString(_ctx.formatZipCode(_ctx.options.updatedAddress.visitZipCode)), 3 /* TEXT, CLASS */),
                              _createElementVNode("p", {
                                class: _normalizeClass(`m-0 ${_ctx.checkEqualAddress(_ctx.options.originalAddress.visitCounty, _ctx.options.updatedAddress.visitCounty)}`)
                              }, _toDisplayString(_ctx.options.updatedAddress.visitCounty), 3 /* TEXT, CLASS */),
                              _createElementVNode("p", {
                                class: _normalizeClass(`m-0 ${_ctx.originalAddressCountry && _ctx.updatedAddressCountry && _ctx.originalAddressCountry === _ctx.updatedAddressCountry ? '' : 'text-danger'}`)
                              }, _toDisplayString(_ctx.updatedAddressCountry), 3 /* TEXT, CLASS */)
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("label", _hoisted_39, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input au-target",
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.options.updatedAddress.visitUpdate) = $event))
                          }, null, 512 /* NEED_PATCH */), [
                            [_vModelCheckbox, _ctx.options.updatedAddress.visitUpdate]
                          ]),
                          _hoisted_40
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_41, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_42, [
                    _hoisted_43,
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("address", null, [
                        _createTextVNode(_toDisplayString(_ctx.options.originalAddress.mailingAddressLine1) + " ", 1 /* TEXT */),
                        (_ctx.options.originalAddress.mailingAddressLine2?.length > 0)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(_ctx.options.originalAddress.mailingAddressLine2), 1 /* TEXT */))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.options.originalAddress.mailingCity), 1 /* TEXT */),
                        _createElementVNode("p", _hoisted_47, _toDisplayString(_ctx.options.originalAddress.mailingState) + " " + _toDisplayString(_ctx.options.originalAddress.mailingZipCode ? "," : "") + " " + _toDisplayString(_ctx.formatZipCode(_ctx.options.originalAddress.mailingZipCode)), 1 /* TEXT */),
                        _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.options.originalAddress.mailingCounty), 1 /* TEXT */),
                        _createElementVNode("p", _hoisted_49, _toDisplayString(_ctx.originalAddressCountry), 1 /* TEXT */)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_50, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_51, [
                    _hoisted_52,
                    _createElementVNode("p", _hoisted_53, [
                      _createElementVNode("address", null, [
                        _createElementVNode("p", {
                          class: _normalizeClass(`m-0 ${_ctx.checkEqualAddress(_ctx.options.originalAddress.mailingAddressLine1, _ctx.options.updatedAddress.mailingAddressLine1)}`)
                        }, _toDisplayString(_ctx.options.updatedAddress.mailingAddressLine1), 3 /* TEXT, CLASS */),
                        (_ctx.options.updatedAddress.mailingAddressLine2?.length > 0)
                          ? (_openBlock(), _createElementBlock("p", {
                              key: 0,
                              class: _normalizeClass(`m-0 ${_ctx.checkEqualAddress(_ctx.options.originalAddress.mailingAddressLine2, _ctx.options.updatedAddress.mailingAddressLine2)}`)
                            }, _toDisplayString(_ctx.options.updatedAddress.mailingAddressLine2), 3 /* TEXT, CLASS */))
                          : _createCommentVNode("v-if", true),
                        _createElementVNode("p", {
                          class: _normalizeClass(`m-0 ${_ctx.checkEqualAddress(_ctx.options.originalAddress.mailingCity, _ctx.options.updatedAddress.mailingCity)}`)
                        }, _toDisplayString(_ctx.options.updatedAddress.mailingCity), 3 /* TEXT, CLASS */),
                        _createElementVNode("p", {
                          class: _normalizeClass(`m-0 ${_ctx.checkEqualAddress(_ctx.options.originalAddress.mailingState, _ctx.options.updatedAddress.mailingState)} 
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                              ${_ctx.checkEqualAddress(_ctx.options.originalAddress.mailingZipCode, _ctx.options.updatedAddress.mailingZipCode)}`)
                        }, _toDisplayString(_ctx.options.updatedAddress.mailingState) + " " + _toDisplayString(_ctx.options.updatedAddress.mailingZipCode ?
                                            "," : "") + " " + _toDisplayString(_ctx.formatZipCode(_ctx.options.updatedAddress.mailingZipCode)), 3 /* TEXT, CLASS */),
                        _createElementVNode("p", {
                          class: _normalizeClass(`m-0 ${_ctx.checkEqualAddress(_ctx.options.originalAddress.mailingCounty, _ctx.options.updatedAddress.mailingCounty)}`)
                        }, _toDisplayString(_ctx.options.updatedAddress.mailingCounty), 3 /* TEXT, CLASS */),
                        _createElementVNode("p", _hoisted_54, _toDisplayString(_ctx.updatedAddressCountry), 1 /* TEXT */)
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _createElementVNode("label", _hoisted_56, [
                    _withDirectives(_createElementVNode("input", {
                      class: "form-check-input au-target",
                      type: "checkbox",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.options.updatedAddress.mailingUpdate) = $event))
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelCheckbox, _ctx.options.updatedAddress.mailingUpdate]
                    ]),
                    _hoisted_57
                  ])
                ])
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (!_ctx.validAddress)
        ? (_openBlock(), _createElementBlock("div", _hoisted_58, _hoisted_60))
        : _createCommentVNode("v-if", true)
    ]),
    _hoisted_61,
    _createElementVNode("div", _hoisted_62, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-light border border-secondary me-1",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cancel()))
      }, _toDisplayString(_ctx.validAddress ? "Keep Current Address" : "Cancel"), 1 /* TEXT */),
      (_ctx.validAddress)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-primary border border-primary",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.ok()))
          }, " Use Validated Address "))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}